import { TypedDocumentNode } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import type { MongoCountriesType } from "@/types";
import { queries } from "@/graphql";

interface GetCountriesResponse {
  getCustomersCountry: Array<MongoCountriesType | null> | null;
}

interface GetCountriesVariables {
  customerId: string; // Change to number or string | null if needed
  subsidiaryId: string; // Change to number or string | null if needed
}

const getCountriesTyped = queries.getCustomerCountries as TypedDocumentNode<
  GetCountriesResponse,
  GetCountriesVariables
>;

export const useCustomerCountries = (
  customerId?: string,
  subsidiaryId?: string,
) => {
  const hasValidParams = Boolean(customerId && subsidiaryId);

  const { data, loading } = useQuery(getCountriesTyped, {
    variables: {
      customerId: customerId || "",
      subsidiaryId: subsidiaryId || "",
    },
    skip: !hasValidParams,
  });

  //   const { buildings } = useCompanyBuildings(customerId, subsidiaryId);

  // console.log(data);

  //   const countries = useMemo(() => {
  //     let returnValue: Array<MongoCountriesType> = [];

  //     if (data?.getCustomersCountry) {
  //       console.log(data.getCustomersCountry);

  //       // let filteredCountries: Array<MongoCountriesType> = data.getCustomersCountry.filter(
  //       //   (country): country is MongoCountriesType => Boolean(country),
  //       // );
  //       // if (customerId && subsidiaryId) {
  //       //   const uniqueCountries = [
  //       //     ...new Set(
  //       //       buildings?.map((building: BuildingMetersType) => building?.country).filter(
  //       //         (country): country is string => Boolean(country),
  //       //       ) || [],
  //       //     ),
  //       //   ];
  //       //   filteredCountries = filteredCountries.filter((country) =>
  //       //     Boolean(country.code) && uniqueCountries.includes(country.code),
  //       //   );
  //       // }

  //       // returnValue = sortArrayByField(filteredCountries, "name") as Array<MongoCountriesType>;
  //     }
  //     return returnValue;
  //   }, [buildings, subsidiaryId, data?.getCustomersCountry, customerId]);

  return {
    countries: data?.getCustomersCountry || [],
    loading,
  };
};
